var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFC59C",
    d: "M14.288.99L.322 25.18a1.977 1.977 0 001.712 2.967h27.932a1.977 1.977 0 001.712-2.967L17.712.99a1.978 1.978 0 00-3.424 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B27C50",
    d: "M15.739 1.827L1.773 26.017a.302.302 0 00.26.454H16V1.675a.285.285 0 00-.261.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#966944",
    d: "M30.227 26.32a.286.286 0 000-.303L16.261 1.827A.285.285 0 0016 1.675v24.796h13.966a.285.285 0 00.261-.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16 3.05l13.039 22.584H2.96L16 3.049zm0-1.375a.285.285 0 00-.261.151L1.773 26.017a.302.302 0 00.26.454h27.933a.302.302 0 00.261-.453L16.261 1.827A.285.285 0 0016 1.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M14.892 17.695c.042.27.09.542.143.817h1.987c.112-.593.203-1.175.274-1.746.063-.523.098-1.05.102-1.578V9.627H14.66v5.412c0 .578.034 1.154.104 1.727.035.307.078.616.128.929zm2.646 3.598a1.566 1.566 0 00-.355-.51 1.728 1.728 0 00-.53-.346A1.675 1.675 0 0016 20.31a1.665 1.665 0 00-1.188.473 1.582 1.582 0 00-.477 1.144c-.002.22.042.437.127.64.165.391.48.7.875.856.211.084.436.125.663.123.223.002.445-.04.653-.123.197-.079.377-.195.53-.341.152-.146.273-.321.355-.515.085-.203.129-.42.127-.64a1.582 1.582 0 00-.127-.634z"
  }))));
}
export default SvgWarning;